export default {
  root: ({ props, context, parent }) => ({
    class: [
      // Font
      'leading-[normal]',
      'text-base',

      'appearance-none',

      // Flex
      { 'flex-1 w-[1%]': parent.instance.$name == 'InputGroup' },

      // Spacing
      'm-0',
      {
        'px-4 py-4': props.size == 'large',
        'px-2 py-2': props.size == 'small',
        'px-3 py-1': props.size == null
      },

      // Shape
      'rounded',
      {
        'first:rounded-l-2xl rounded-none last:rounded-r-2xl':
          parent.instance.$name == 'InputGroup'
      },
      {
        'border-0 border-y border-l last:border-r':
          parent.instance.$name == 'InputGroup'
      },
      {
        'first:ml-0 -ml-px':
          parent.instance.$name == 'InputGroup' && !props.showButtons
      },

      // Colors
      'text-surface-700 dark:text-white/80',
      'border border-zinc-300 dark:border-zinc-700 bg-white',
      { 'border-surface-300 dark:border-surface-600': !props.invalid },

      // Invalid State
      'invalid:hover:border-red-500',

      // States
      {
        'hover:border-primary focus:outline-none focus:outline-offset-0 focus:ring focus:ring-primary-500/50 dark:focus:ring-primary-400/50 focus:z-10':
          !context.disabled && !props.invalid,
        'text-red-600 focus:border-red-500 focus:outline-offset-0 focus:ring focus:ring-red-500/50 dark:focus:ring-red-400/50 focus:z-10':
          props.invalid,
        'opacity-60 select-none pointer-events-none cursor-default':
          context.disabled
      },

      // Filled State *for FloatLabel
      { filled: parent.instance?.$name == 'FloatLabel' && context.filled },

      // Misc
      'appearance-none',
      'transition-colors duration-200'
    ]
  })
}
